var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurtains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23 3H1V1h22zM2 22h4c0-3-2-5-2-5c6-4 7-13 7-13H2zM22 4h-9s1 9 7 13c0 0-2 2-2 5h4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurtains);
export default __webpack_public_path__ + "static/media/curtains.a6bb46e90435d0f67181a4e38220895f.svg";
export { ForwardRef as ReactComponent };